import * as types from './_actionTypes';

const initialState = {
  assessments: [],
  currentAssessment: null,
  assessmentAnswers: {},
  assessmentResults: [],
  loading: false,
  submitting: false,
  error: null
};

const studentAssessmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ASSESSMENTS_REQUEST:
    case types.FETCH_ASSESSMENT_RESULTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        assessments: action.payload,
        error: null
      };
    
    case types.FETCH_ASSESSMENT_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        assessmentResults: action.payload,
        error: null
      };
    
    case types.FETCH_ASSESSMENTS_FAILURE:
    case types.FETCH_ASSESSMENT_RESULTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.START_ASSESSMENT_SUCCESS:
      return {
        ...state,
        currentAssessment: action.payload,
        assessmentAnswers: {},
        error: null
      };
    
    case types.START_ASSESSMENT_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    
    case types.SUBMIT_ASSESSMENT_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null
      };
    
    case types.SUBMIT_ASSESSMENT_SUCCESS:
      return {
        ...state,
        submitting: false,
        currentAssessment: null,
        assessmentAnswers: {},
        assessmentResults: [action.payload, ...state.assessmentResults],
        error: null
      };
    
    case types.SUBMIT_ASSESSMENT_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload
      };
    
    case types.UPDATE_ASSESSMENT_ANSWER:
      return {
        ...state,
        assessmentAnswers: {
          ...state.assessmentAnswers,
          [action.payload.questionId]: action.payload.answer
        }
      };
    
    default:
      return state;
  }
};

export default studentAssessmentsReducer;